import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Full-screen page-transition overlay that shows the Global Pneus logo
 * spinning for ~700ms every time the route changes.
 */
const SpinningLogo = () => (
  <img
    src="/logo-global-pneus.png"
    alt=""
    aria-hidden="true"
    className="w-24 h-24 md:w-32 md:h-32 object-contain drop-shadow-[0_10px_40px_rgba(255,90,0,0.4)]"
    style={{ animation: "logoSpin 900ms linear infinite" }}
  />
);

const RouteTransition = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 650);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <div
      data-testid="route-transition"
      aria-hidden={!visible}
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0A0F1E]/95 backdrop-blur-md pointer-events-none transition-opacity duration-200 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      <SpinningLogo />
      <div className="mt-5 text-[10px] md:text-xs uppercase tracking-[0.4em] text-[#FF5A00] font-display font-bold">
        A carregar
      </div>
      <style>{`
        @keyframes logoSpin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default RouteTransition;
